import type { MergedCatalogProductDetails } from '../../api/queries/getCatalogProductDetails';

export type SwatchHover = Readonly<{
  itemId: string;
  fromCatalogItemId: string;
}>;

type ResolveHoverPreviewProductArgs = Readonly<{
  hover: SwatchHover | null;
  catalogItemId: string;
  prefetchedProduct: MergedCatalogProductDetails;
}>;

export const resolveHoverPreviewProduct = ({ hover, catalogItemId, prefetchedProduct }: ResolveHoverPreviewProductArgs) => {
  if (!hover || hover.fromCatalogItemId !== catalogItemId || hover.itemId === catalogItemId || prefetchedProduct?.id !== hover.itemId) {
    return null;
  }
  return prefetchedProduct;
};
